function addCountryNoShippingText(){
const renderNoShippingText = () => {
  const app = document.getElementById('app')
  const showPdpChangeCountryText = window.show_case_pdp_change_country_text !== false

  if (!app) return
  if (document.querySelector('.text-no-shipping')) return

  const paragraph = document.createElement('p')
  paragraph.classList.add('text-no-shipping')
  
  paragraph.textContent = window.no_shipping_country || ''

  if (showPdpChangeCountryText) {
    const changeCountrySentence = window.no_shipping_country_change_country_text || ''

    if (changeCountrySentence) {
      paragraph.appendChild(document.createTextNode(` ${changeCountrySentence}`))
      paragraph.appendChild(document.createTextNode(' '))
    }

    const link = document.createElement('a')
    link.classList.add('country_splash_open')
    link.textContent = window.change_country_text || ''
    link.href = '#'

    paragraph.appendChild(link)
  }

  app.insertAdjacentElement('afterend', paragraph)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderNoShippingText, { once: true })
} else {
  renderNoShippingText()
}
}

class ShippingValidator {
  constructor() {
    this.apiUrl = '/api/2025-10/graphql.json'

    this.headers = {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': window.token_storefront,
    }

    this.storageKeys = {
      countries: 'shipping_allowed_countries',
      restricted: 'is_country_restricted',
      userCountry: 'detected_user_country',
    }

    this.cssClass = 'country_not_available'
    this.targetElement = document.documentElement

    this.init()
  }

  setRestrictedState(isRestricted) {
    if (isRestricted) {
      sessionStorage.setItem(this.storageKeys.restricted, 'true')
      this.targetElement.classList.add(this.cssClass)
      addCountryNoShippingText()
    } else {
      sessionStorage.removeItem(this.storageKeys.restricted)
      this.targetElement.classList.remove(this.cssClass)
    }
  }

  async detectUserCountry() {
    if (window.test_country_showcase) return 'ZZ'

    if (window.show_case_country_source === 'liquid' && window.show_case_liquid_country) {
      return window.show_case_liquid_country
    }

    try {
      const url = `${window.location.origin}/browsing_context_suggestions.json?country[enabled]=true`

      const response = await fetch(url)
      if (!response.ok) throw new Error('Geo API failed')

      const data = await response.json()
      const countryCode = data?.detected_values?.country?.handle

      if (countryCode) {
        return countryCode
      }
    } catch {}

    return window.Shopify?.country || null
  }

  async fetchShippableCountries() {
    try {
      const query = `query { shop { shipsToCountries } }`
      const response = await fetch(this.apiUrl, {
        method: 'POST',
        headers: this.headers,
        body: JSON.stringify({ query }),
      })
      const { data } = await response.json()
      return data?.shop?.shipsToCountries || []
    } catch {
      return []
    }
  }

  async validateCountry() {
    const userCountry = await this.detectUserCountry()

    if (!userCountry) return

    let allowedCountries = sessionStorage.getItem(this.storageKeys.countries)

    if (allowedCountries) {
      allowedCountries = JSON.parse(allowedCountries)
    } else {
      allowedCountries = await this.fetchShippableCountries()
      if (allowedCountries.length > 0) {
        sessionStorage.setItem(
          this.storageKeys.countries,
          JSON.stringify(allowedCountries)
        )
      }
    }

    if (allowedCountries.length > 0) {
      const isAllowed = allowedCountries.includes(userCountry)
      this.setRestrictedState(!isAllowed)
    }
  }

  init() {
    if (sessionStorage.getItem(this.storageKeys.restricted) === 'true') {
      this.targetElement.classList.add(this.cssClass)
    }

    this.validateCountry()
  }
}

new ShippingValidator()




